import { defineComponent, ref, Ref, onMounted, watch, computed } from "vue";

interface IData {
    timeZoneList: Ref<ISelectItem[]>,
    timeZoneListUnfiltered: Ref<ISelectItem[]>,
    selectedTimeZone: Ref<ISelectItem | null>,
    showTimeZoneList: Ref<boolean>,
    searchTermTimeZone: Ref<string>
}

export interface ISelectItem {
    value: string,
    display: string,
    terms?: string
};

const getInitialData = function (props: any) {
    return {
        timeZoneList: ref<ISelectItem[]>([]),
        timeZoneListUnfiltered: ref<ISelectItem[]>([]),
        selectedTimeZone: ref<ISelectItem | null>(null),
        showTimeZoneList: ref<boolean>(false),
        searchTermTimeZone: ref<string>(props.selectedTimeZone ?? "")
    }
}

const getComputed = function (data: IData, props: any) {
    return {
        isShowResults: computed(() => {
            return (data.showTimeZoneList.value && data.timeZoneList.value.length > 0);
        })
    }
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        selectTimeZone: function (timeZone?: ISelectItem) {
            let index;
            if (props.index != undefined || props.index != null) {
                index = props.index;
            } else {
                index = null;
            }

            if (timeZone) {
                data.selectedTimeZone.value = timeZone;
                ctx.emit('select-timezone', timeZone, index);
            } else {
                data.selectedTimeZone.value = null;
                ctx.emit('select-timezone', null, null);
                data.searchTermTimeZone.value = "";
            }
            data.showTimeZoneList.value = false;
            
        }
    }
}

const findTimeZones = function (data: IData, props: any) {
    var timeZones = props.timeZones as string[];

    timeZones = timeZones.filter(function (t) { return t.toLowerCase().includes(data.searchTermTimeZone.value.toLowerCase()) });

    data.timeZoneList.value = timeZones.map(r => ({
        value: r,
        display: r,
        terms: r
    }));

    data.timeZoneListUnfiltered.value = data.timeZoneList.value;
};

export default defineComponent({
    name: "TimeZoneLookup",
    props: {
        timeZones: {
            type: Array as () => string[],
            required: false
        },
        selectedTimeZone: {
            type: String,
            required: false
        }
    },
    emits: ['select-timezone'],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);
        let computed = getComputed(data, props);

        onMounted(() => {
            findTimeZones(data, props);
        });

        watch(() => data.searchTermTimeZone.value, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                findTimeZones(data, props)
            } else {
                data.timeZoneList.value = data.timeZoneListUnfiltered.value;
            }
        });

        watch(
            () => props.selectedTimeZone, (newVal, oldVal) => {
                if (newVal && newVal.length > 0) {
                    findTimeZones(data, props);
                    data.searchTermTimeZone.value = newVal;
                } else {
                    data.timeZoneList.value = data.timeZoneListUnfiltered.value;
                }
            },
            { deep: true }
        );

        return {
            ...data,
            ...methods,
            ...computed
        }
    }
});